import { render } from "./VODUploadWidgetLight.vue?vue&type=template&id=63a01d41&scoped=true"
import script from "./VODUploadWidgetLight.vue?vue&type=script&lang=js"
export * from "./VODUploadWidgetLight.vue?vue&type=script&lang=js"

import "./VODUploadWidgetLight.vue?vue&type=style&index=0&id=63a01d41&scoped=true&lang=css"
import "./VODUploadWidgetLight.vue?vue&type=style&index=1&id=63a01d41&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a01d41"],['__file',"src/components/ui/VODUploadWidgetLight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63a01d41"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63a01d41', __exports__)) {
    api.reload('63a01d41', __exports__)
  }
  
  module.hot.accept("./VODUploadWidgetLight.vue?vue&type=template&id=63a01d41&scoped=true", () => {
    api.rerender('63a01d41', render)
  })

}


export default __exports__